import CreateDealRoom from './CreateDealRoom.page';

export default CreateDealRoom;
